/**
 * Uppercase section caption, matching the prototype's `.evm-section-title`
 * (11px / 600 / uppercase / letter-spacing 0.06em / muted, 10px below).
 */
function SectionLabel({ children }) {
  return (
    <p className="mb-2.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-content-faint">
      {children}
    </p>
  );
}

export default SectionLabel;
